import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductRangesComponent } from './product-ranges/product-ranges.component';
import { ProductRangeEditComponent } from './product-range-edit/product-range-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { SharedModule } from '../shared/shared.module';
import { ProductRangeRoutingModule } from './product-range.routing.module';
import { ProductRangeConfigureComponent } from './product-range-configure/product-range-configure.component';
import { CmsModule } from '../cms/cms.module';
import { StandardStonePricingComponent } from './standard-stone-pricing/standard-stone-pricing.component';
import { NgSelectModule } from '@ng-select/ng-select';



@NgModule({
    declarations: [
        ProductRangesComponent,
        ProductRangeEditComponent,
        ProductRangeConfigureComponent,
        StandardStonePricingComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        DropzoneModule,
        ProductRangeRoutingModule,
        CmsModule,
        NgSelectModule,
    ],
    exports: [
        StandardStonePricingComponent,
    ]
})
export class ProductRangeModule { }
